export default theme => ({
  row: {
    alignItems: "center",
    padding: "20px",
    backgroundColor: theme.palette.common.white,
    marginTop: theme.spacing(1)
  },

  connectionsContainer: {
    width: "100%"
  },

  spacer: {
    flexGrow: 1
  },
  searchInput: {
    marginRight: theme.spacing(1)
  },
  rowContent: {
    marginRight: "10px",
    marginLeft: "10px"
  },
  listHeader: {
    justifyContent: "space-between"
  },
  viewContainer: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  },
  titleContainer: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center"
  },
  title: {
    fontSize: "24px",
    marginRight: theme.spacing(2),
    color: theme.palette.text.secondary
  },
  numberOfIntents: {
    color: theme.palette.common.muted
  },
  grow: {
    flexGrow: 1
  },
  changeView: {
    marginRight: theme.spacing(3)
  },
  viewIcon: {
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
    borderRadius: "3px",
    border: "solid 1px #efefef"
  },
  viewIconSelected: {
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
    borderRadius: "3px",
    border: "solid 1px #efefef",
    backgroundColor: "#efefef",
    color: "#b6b6b6"
  },
  sortBy: {
    display: "flex",
    flexFlow: "row wrap",
    alignItems: "center",
    color: theme.palette.text.secondary
  },
  sortByText: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    fontSize: "11px",
    textTransform: "uppercase",
    color: theme.palette.text.secondary
  },
  sortByButton: {
    // backgroundColor: 'pink',
    // color: theme.palette.text.secondary
    color: "#9f9f9f"
  },
  selectOption: {
    color: "#9f9f9f"
  },
  list: {
    display: "flex",
    flexWrap: "wrap",
    borderBottom: "1px solid #eee",
    paddingBottom: 0
  }
});
